import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import { RightChevron } from 'appSrc/components/UI';
import style from './styles/style.module.css';

const defaultArrowProps = {
    size: 14,
};

export default class InternalLink extends PureComponent {
    render() {
        const arrowProps = {
            ...defaultArrowProps,
            ...this.props.arrowProps,
            className: `${ style.linkArrow } ${ this.props.arrowProps.className || '' }`,
        };
        var to = this.props.to;
        to = to.replace( /^https?:\/\//, '' ).replace( /.*desirelist\.com/, '' );

        const updatedProps = {
            ...this.props,
            to: to,
            className: `${ style.internalLink } ${ this.props.className }`.trim(),
        };
        delete updatedProps.arrowProps;
        delete updatedProps.children;
        delete updatedProps.arrow;


        return (
            <Link { ...updatedProps }>
                { this.props.children }
                { this.props.arrow &&
                    <RightChevron { ...arrowProps } />
                }
            </Link>
        );
    }
}
InternalLink.defaultProps = {
    to: '#',
    rel: 'noopener noreferrer',
    children: null,
    className: '',
    arrowProps: {},
};
